import type { Segno } from '../types'

export type SegnoMoveDirection = -1 | 1

/** 세뇨 순번을 기준으로 화면과 재생 순서를 일관되게 정렬합니다. */
export function orderedSegnos(segnos: Segno[]): Segno[] {
  return segnos.slice().sort((left, right) => left.order - right.order)
}

/** 처음 화면을 열 때 선택할 첫 세뇨 순번을 반환합니다. */
export function firstSegnoOrder(segnos: Segno[]): number | null {
  return orderedSegnos(segnos)[0]?.order ?? null
}

/** 현재 세뇨의 바로 앞 또는 뒤 세뇨를 반환하며 양 끝에서는 null을 반환합니다. */
export function adjacentSegno(
  segnos: Segno[],
  currentOrder: number | null,
  direction: SegnoMoveDirection,
): Segno | null {
  const ordered = orderedSegnos(segnos)
  if (ordered.length === 0) return null

  const currentIndex = Math.max(0, ordered.findIndex((segno) => segno.order === currentOrder))
  const targetIndex = currentIndex + direction
  if (targetIndex < 0 || targetIndex >= ordered.length) return null
  return ordered[targetIndex]
}
